<p>Elenco decreti di approvazione di inserimento o variazione di figure professionali e di competenze</p>

<div class="example-container mat-elevation-z8">
  <div class="example-table-container">
    <table mat-table [dataSource]="dataSource" class="example-table" matSort (matSortChange)="sortData($event)" matSortActive="dataDecreto"
      matSortDirection="asc">
      <ng-container matColumnDef="dataDecreto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
          Data Decreto
        </th>
        <td mat-cell *matCellDef="let element"> {{element.dataDecreto | date: 'dd/MM/yyyy'}} </td>
      </ng-container>
      <ng-container matColumnDef="nomeDecreto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
          Nome Decreto
        </th>
        <td mat-cell *matCellDef="let element"> {{element.nomeDecreto}} </td>
      </ng-container>
      <ng-container matColumnDef="azioni">
        <th mat-header-cell *matHeaderCellDef>
          Azioni
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-icon class="green" (click)="downloadDecreto(element)" matTooltip="Download Decreto">download
          </mat-icon>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height:24px !important;"></tr>
    </table>
  </div>

  <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [length]="totalItems"
    [pageIndex]="pageIndex" (page)="onPaginateChange($event)" showFirstLastButtons></mat-paginator>
</div>
